module.exports = __webpack_public_path__ + "img/Group 1738@3x.837dbaed.png";